import { motion } from 'framer-motion';

const animations = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

// Stays mounted when hidden so children keep their state; fades in when shown.
const AnimatedPage = ({ children, visible = true }) => {
  return (
    <motion.div
      variants={animations}
      initial='initial'
      animate={visible ? 'animate' : 'initial'}
      exit='exit'
      transition={{ duration: 1 }}
      style={visible ? undefined : { display: 'none' }}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedPage;
